// Generated by purs version 0.15.15
import * as Common from "../Common/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_List from "../Data.List/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Number from "../Data.Number/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Pitches_Class from "../Data.Pitches.Class/index.js";
import * as Data_Pitches_Spelled from "../Data.Pitches.Spelled/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Halogen_HTML_Core from "../Halogen.HTML.Core/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_HTML_Events from "../Halogen.HTML.Events/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as Halogen_Query_Input from "../Halogen.Query.Input/index.js";
import * as Halogen_Svg_Attributes from "../Halogen.Svg.Attributes/index.js";
import * as Halogen_Svg_Attributes_Baseline from "../Halogen.Svg.Attributes.Baseline/index.js";
import * as Halogen_Svg_Attributes_Color from "../Halogen.Svg.Attributes.Color/index.js";
import * as Halogen_Svg_Attributes_TextAnchor from "../Halogen.Svg.Attributes.TextAnchor/index.js";
import * as Halogen_Svg_Elements from "../Halogen.Svg.Elements/index.js";
import * as ProtoVoices_Model from "../ProtoVoices.Model/index.js";
var pitchIsSymbol = {
    reflectSymbol: function () {
        return "pitch";
    }
};
var idIsSymbol = {
    reflectSymbol: function () {
        return "id";
    }
};
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(pitchIsSymbol)(/* #__PURE__ */ Data_Pitches_Class.eqPitch(Data_Pitches_Spelled.eqSInterval)))()(idIsSymbol)(Data_Eq.eqString)));
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(ProtoVoices_Model.ordSliceId);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var ordRecord = /* #__PURE__ */ Data_Ord.ordRecord();
var ordRecordCons = /* #__PURE__ */ Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)();
var ordStartStop = /* #__PURE__ */ ProtoVoices_Model.ordStartStop(/* #__PURE__ */ ordRecord(/* #__PURE__ */ Data_Ord.ordRecordCons(/* #__PURE__ */ ordRecordCons(pitchIsSymbol)(/* #__PURE__ */ Data_Pitches_Class.ordPitch(Data_Pitches_Spelled.ordSInterval)))()(idIsSymbol)(Data_Ord.ordString)));
var ordRecord1 = /* #__PURE__ */ ordRecord(/* #__PURE__ */ Data_Ord.ordRecordCons(/* #__PURE__ */ ordRecordCons({
    reflectSymbol: function () {
        return "right";
    }
})(ordStartStop))()({
    reflectSymbol: function () {
        return "left";
    }
})(ordStartStop));
var fromFoldable = /* #__PURE__ */ Data_Set.fromFoldable(Data_Foldable.foldableArray)(ordRecord1);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Control_Bind.bindArray);
var fromFoldable1 = /* #__PURE__ */ Data_Array.fromFoldable(Data_Set.foldableSet);
var eq1 = /* #__PURE__ */ Data_Eq.eq(ProtoVoices_Model.eqNoteExplanation);
var fromFoldable2 = /* #__PURE__ */ Data_Map_Internal.fromFoldable(Data_Ord.ordString)(Data_Foldable.foldableArray);
var unions = /* #__PURE__ */ Data_Map_Internal.unions(Data_Ord.ordString)(Data_Foldable.foldableArray);
var maximum = /* #__PURE__ */ Data_Foldable.maximum(Data_Ord.ordInt)(Data_List_Types.foldableList);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_List_Types.functorList);
var diasteps = /* #__PURE__ */ Data_Pitches_Spelled.diasteps(/* #__PURE__ */ Data_Pitches_Spelled.spelledPitch(Data_Pitches_Spelled.spelledSInterval)(Data_Pitches_Spelled.hasIntervalClassSInterval)(Data_Pitches_Spelled.spelledSIC));
var minimum = /* #__PURE__ */ Data_Foldable.minimum(Data_Ord.ordInt)(Data_List_Types.foldableList);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var lookup1 = /* #__PURE__ */ Data_Map_Internal.lookup(Data_Ord.ordString);
var showPitch = /* #__PURE__ */ Data_Pitches_Class.showPitch(Data_Pitches_Spelled.notationPitchSInterval);
var show = /* #__PURE__ */ Data_Show.show(showPitch);
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var showRecord1 = /* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(idIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(pitchIsSymbol)(showPitch))(Data_Show.showString));
var show1 = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ ProtoVoices_Model.showStartStop(showRecord1));
var member = /* #__PURE__ */ Data_Map_Internal.member(Data_Ord.ordString);
var member1 = /* #__PURE__ */ Data_Set.member(ordRecord1);
var fromFoldable3 = /* #__PURE__ */ Data_Array.fromFoldable(Data_List_Types.foldableList);
var show2 = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ ProtoVoices_Model.showStartStop(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "expl";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "note";
    }
})(showRecord1))(ProtoVoices_Model.showNoteExplanation)))));
var fromFoldable4 = /* #__PURE__ */ Data_Array.fromFoldable(Data_Foldable.foldableArray);
var max = /* #__PURE__ */ Data_Ord.max(Data_Ord.ordInt);
var eq3 = /* #__PURE__ */ Data_Eq.eq(ProtoVoices_Model.eqStaff);
var NotSelected = /* #__PURE__ */ (function () {
    function NotSelected() {

    };
    NotSelected.value = new NotSelected();
    return NotSelected;
})();
var Selected = /* #__PURE__ */ (function () {
    function Selected() {

    };
    Selected.value = new Selected();
    return Selected;
})();
var Related = /* #__PURE__ */ (function () {
    function Related() {

    };
    Related.value = new Related();
    return Related;
})();
var white = /* #__PURE__ */ (function () {
    return new Halogen_Svg_Attributes_Color.RGB(255, 255, 255);
})();
var warnColor = /* #__PURE__ */ (function () {
    return new Halogen_Svg_Attributes_Color.RGB(255, 165, 0);
})();
var tspan = /* #__PURE__ */ Halogen_Svg_Elements.element("tspan");
var svgFilter = /* #__PURE__ */ Halogen_HTML_Properties.attr("filter");
var sliceWidth = 70.0;
var selColorOuter$prime = /* #__PURE__ */ (function () {
    return new Halogen_Svg_Attributes_Color.RGB(135, 206, 250);
})();
var selColorOuter = /* #__PURE__ */ (function () {
    return new Halogen_Svg_Attributes_Color.RGB(30, 144, 255);
})();
var selColorInner$prime = selColorOuter$prime;
var selColorInner = selColorOuter;
var scoreScale = 0.9;
var scoreHeightSingle = 80.0;
var scoreHeightGrand = 150.0;
var scaley = function (v) {
    return function (y) {
        return y * 100.0 * Data_Number.exp(v.yscale);
    };
};
var scalex = function (v) {
    return function (x) {
        return x * sliceWidth * Data_Number.exp(v.xscale);
    };
};
var parentColor = selColorInner$prime;
var offset = function (i) {
    return Data_Int.toNumber(i) * 20.0;
};
var noteSize = 29.0;
var noteSelectionStatus = function (sel) {
    return function (note) {
        var selected = Common.noteIsSelected(sel)(new ProtoVoices_Model.Inner(note));
        var parentSelected = (function () {
            if (sel instanceof Data_Maybe.Just) {
                return ProtoVoices_Model.explHasParent(note.id)(sel.value0.expl);
            };
            if (sel instanceof Data_Maybe.Nothing) {
                return false;
            };
            throw new Error("Failed pattern match at Render (line 121, column 20 - line 123, column 21): " + [ sel.constructor.name ]);
        })();
        if (selected) {
            return Selected.value;
        };
        if (parentSelected) {
            return Related.value;
        };
        return NotSelected.value;
    };
};
var lightgray = /* #__PURE__ */ (function () {
    return new Halogen_Svg_Attributes_Color.RGB(211, 211, 211);
})();
var innerFactor = 1.6;
var findPitchIndex = function (v) {
    return function (v1) {
        if (v instanceof ProtoVoices_Model.Inner && v1 instanceof ProtoVoices_Model.Inner) {
            return Data_Maybe.fromMaybe(-1 | 0)(Data_Array.findIndex(function (n) {
                return eq(n.note)(v.value0);
            })(v1.value0));
        };
        return 0;
    };
};
var errColor = /* #__PURE__ */ (function () {
    return new Halogen_Svg_Attributes_Color.RGB(255, 0, 0);
})();
var eqSelectionStatus = {
    eq: function (x) {
        return function (y) {
            if (x instanceof NotSelected && y instanceof NotSelected) {
                return true;
            };
            if (x instanceof Selected && y instanceof Selected) {
                return true;
            };
            if (x instanceof Related && y instanceof Related) {
                return true;
            };
            return false;
        };
    }
};
var eq4 = /* #__PURE__ */ Data_Eq.eq(eqSelectionStatus);
var dy = /* #__PURE__ */ Halogen_HTML_Properties.attr("dy");
var cursor = /* #__PURE__ */ Halogen_HTML_Properties.attr("cursor");
var black = /* #__PURE__ */ (function () {
    return new Halogen_Svg_Attributes_Color.RGB(0, 0, 0);
})();
var renderHori = function (sett) {
    return function (selection) {
        return function (slices) {
            return function (v) {
                var explToHori = function (note) {
                    if (note.expl instanceof ProtoVoices_Model.HoriExpl) {
                        return new Data_Maybe.Just({
                            childNote: note.note,
                            parentNote: note.expl.value0
                        });
                    };
                    return Data_Maybe.Nothing.value;
                };
                return Data_Maybe.fromMaybe(Halogen_HTML_Core.text(""))(bind(lookup(v.child)(slices))(function (v1) {
                    return bind(lookup(v.parent)(slices))(function (v2) {
                        var mkedge = function (v3) {
                            var offp = findPitchIndex(new ProtoVoices_Model.Inner(v3.parentNote))(v2.slice.notes);
                            var offc = findPitchIndex(new ProtoVoices_Model.Inner(v3.childNote))(v1.slice.notes);
                            var edgeSelected = Common.noteIsSelected(selection)(new ProtoVoices_Model.Inner(v3.parentNote)) || Common.noteIsSelected(selection)(new ProtoVoices_Model.Inner(v3.childNote));
                            return Halogen_Svg_Elements.line([ Halogen_Svg_Attributes.x1(scalex(sett)(v2.slice.x)), Halogen_Svg_Attributes.y1(scaley(sett)(v2.depth) + offset(offp)), Halogen_Svg_Attributes.x2(scalex(sett)(v1.slice.x)), Halogen_Svg_Attributes.y2(scaley(sett)(v1.depth) + offset(offc)), Halogen_Svg_Attributes.stroke((function () {
                                if (edgeSelected) {
                                    return selColorInner;
                                };
                                return black;
                            })()), Halogen_Svg_Attributes.strokeWidth(1.0) ]);
                        };
                        var edges = map(mkedge)(Data_Array.catMaybes(map(explToHori)(ProtoVoices_Model.getInnerNotes(v1.slice))));
                        var bar = [ Halogen_Svg_Elements.line([ Halogen_Svg_Attributes.x1(scalex(sett)(v2.slice.x)), Halogen_Svg_Attributes.y1(scaley(sett)(v2.depth)), Halogen_Svg_Attributes.x2(scalex(sett)(v1.slice.x)), Halogen_Svg_Attributes.y2(scaley(sett)(v1.depth)), Halogen_Svg_Attributes.stroke(lightgray), Halogen_Svg_Attributes.strokeWidth(5.0), Halogen_HTML_Properties.attr("stroke-dasharray")("10,5") ]) ];
                        return pure(Halogen_Svg_Elements.g([  ])(append(bar)(edges)));
                    });
                }));
            };
        };
    };
};
var renderInner = function (sett) {
    return function (sel) {
        return function (v) {
            return function (graph) {
                var width = scalex(sett)(graph.maxx + 2.0);
                var surfaceEdges = fromFoldable(bind1(v.transs)(function (trans) {
                    return append(fromFoldable1(trans.edges.regular))(trans.edges.passing);
                }));
                var selIsRoot = (function () {
                    if (sel instanceof Data_Maybe.Just) {
                        return eq1(sel.value0.expl)(ProtoVoices_Model.RootExpl.value);
                    };
                    if (sel instanceof Data_Maybe.Nothing) {
                        return false;
                    };
                    throw new Error("Failed pattern match at Render (line 323, column 15 - line 325, column 21): " + [ sel.constructor.name ]);
                })();
                var mkNode = function (v1) {
                    return function (label) {
                        return function (title) {
                            return function (selected) {
                                return function (selAttr) {
                                    return Halogen_Svg_Elements.g([  ])([ Halogen_Svg_Elements.circle(append([ Halogen_Svg_Attributes.cx(v1.x), Halogen_Svg_Attributes.cy(v1.y), Halogen_Svg_Attributes.r(15.0), Halogen_Svg_Attributes.stroke(black), Halogen_Svg_Attributes.fill((function () {
                                        if (selected instanceof NotSelected) {
                                            return white;
                                        };
                                        if (selected instanceof Selected) {
                                            return selColorInner;
                                        };
                                        if (selected instanceof Related) {
                                            return selColorInner$prime;
                                        };
                                        throw new Error("Failed pattern match at Render (line 349, column 23 - line 352, column 42): " + [ selected.constructor.name ]);
                                    })()), cursor("pointer") ])(selAttr)), Halogen_Svg_Elements.element("text")([ Halogen_Svg_Attributes.x(v1.x), Halogen_Svg_Attributes.y(v1.y), Halogen_Svg_Attributes.textAnchor(Halogen_Svg_Attributes_TextAnchor.AnchorMiddle.value), Halogen_Svg_Attributes.dominantBaseline(Halogen_Svg_Attributes_Baseline.BaselineMiddle.value), Halogen_HTML_Properties.style("pointer-events: none;"), Halogen_Svg_Attributes.fill((function () {
                                        var $184 = eq4(selected)(NotSelected.value);
                                        if ($184) {
                                            return black;
                                        };
                                        return white;
                                    })()) ])([ Halogen_HTML_Core.text(label) ]), Halogen_Svg_Elements.title([  ])([ Halogen_HTML_Core.text(title) ]) ]);
                                };
                            };
                        };
                    };
                };
                var extractNotes = function (slice) {
                    return fromFoldable2(map(function (n) {
                        return new Data_Tuple.Tuple(n.note.id, {
                            note: n,
                            x: slice.x
                        });
                    })(ProtoVoices_Model.getInnerNotes(slice)));
                };
                var notes = unions(map(extractNotes)(v.slices));
                var maxy = Data_Maybe.fromMaybe(0)(maximum(map1(function ($267) {
                    return diasteps((function (v1) {
                        return v1.note.note.pitch;
                    })($267));
                })(Data_Map_Internal.values(notes))));
                var miny = Data_Maybe.fromMaybe(0)(minimum(map1(function ($268) {
                    return diasteps((function (v1) {
                        return v1.note.note.pitch;
                    })($268));
                })(Data_Map_Internal.values(notes))));
                var height = innerFactor * offset((maxy - miny | 0) + 2 | 0);
                var notePosition = function (v1) {
                    if (v1 instanceof ProtoVoices_Model.Inner) {
                        return {
                            x: scalex(sett)(Data_Maybe.fromMaybe(0.0)(map2(function (v2) {
                                return v2.x;
                            })(lookup1(v1.value0.id)(notes)))),
                            y: innerFactor * offset(maxy - diasteps(v1.value0.pitch) | 0)
                        };
                    };
                    if (v1 instanceof ProtoVoices_Model.Start) {
                        return {
                            x: 0.0,
                            y: (offset(maxy - miny | 0) * innerFactor) / 2.0
                        };
                    };
                    if (v1 instanceof ProtoVoices_Model.Stop) {
                        return {
                            x: scalex(sett)(graph.maxx),
                            y: (offset(maxy - miny | 0) * innerFactor) / 2.0
                        };
                    };
                    throw new Error("Failed pattern match at Render (line 328, column 18 - line 334, column 89): " + [ v1.constructor.name ]);
                };
                var mkNote = function (v1) {
                    var selected = noteSelectionStatus(sel)(v1.note.note);
                    var selAttr = [ Halogen_HTML_Events.onClick(function (_ev) {
                        return new Common.Select((function () {
                            var $190 = eq4(selected)(Selected.value);
                            if ($190) {
                                return Data_Maybe.Nothing.value;
                            };
                            return new Data_Maybe.Just({
                                note: v1.note.note,
                                expl: v1.note.expl
                            });
                        })());
                    }) ];
                    return mkNode(notePosition(new ProtoVoices_Model.Inner(v1.note.note)))(show(v1.note.note.pitch))(Common.showExplanation(v1.note.expl))(selected)(selAttr);
                };
                var mkStartStop = function (s) {
                    return mkNode(notePosition(s))(show1(s))(show1(s))((function () {
                        if (selIsRoot) {
                            return Related.value;
                        };
                        return NotSelected.value;
                    })())([  ]);
                };
                var surfaceNote = function (v1) {
                    if (v1 instanceof ProtoVoices_Model.Inner) {
                        return member(v1.value0.id)(notes);
                    };
                    return true;
                };
                var mkEdge = function (isRegular) {
                    return function (v1) {
                        if (surfaceNote(v1.left) && surfaceNote(v1.right)) {
                            var v2 = notePosition(v1.left);
                            var v3 = notePosition(v1.right);
                            var edgeSelected = Common.noteIsSelected(sel)(v1.left) || Common.noteIsSelected(sel)(v1.right);
                            return Halogen_Svg_Elements.line(append([ Halogen_Svg_Attributes.x1(v2.x), Halogen_Svg_Attributes.x2(v3.x), Halogen_Svg_Attributes.y1(v2.y), Halogen_Svg_Attributes.y2(v3.y), Halogen_Svg_Attributes.stroke((function () {
                                if (edgeSelected) {
                                    return selColorInner;
                                };
                                var $202 = member1({
                                    left: v1.left,
                                    right: v1.right
                                })(surfaceEdges);
                                if ($202) {
                                    return black;
                                };
                                return lightgray;
                            })()) ])((function () {
                                if (isRegular) {
                                    return [  ];
                                };
                                return [ Halogen_HTML_Properties.attr("stroke-dasharray")("6,3") ];
                            })()));
                        };
                        if (Data_Boolean.otherwise) {
                            return Halogen_HTML_Core.text("");
                        };
                        throw new Error("Failed pattern match at Render (line 379, column 3 - line 400, column 29): " + [ isRegular.constructor.name, v1.constructor.name ]);
                    };
                };
                var svgArrows = bind1(fromFoldable3(Data_Map_Internal.values(graph.transitions)))(function (trans) {
                    return append(map(mkEdge(true))(fromFoldable1(trans.edges.regular)))(map(mkEdge(false))(trans.edges.passing));
                });
                var svgNotes = fromFoldable3(map1(mkNote)(Data_Map_Internal.values(notes)));
                var svg = Halogen_HTML_Elements.div_([ Halogen_Svg_Elements.svg([ Halogen_Svg_Attributes.width(width), Halogen_Svg_Attributes.height(height), Halogen_Svg_Attributes.viewBox(-scalex(sett)(1.0))(-(innerFactor * offset(1)))(width)(height) ])(append(svgArrows)(append(svgNotes)([ mkStartStop(ProtoVoices_Model.Start.value), mkStartStop(ProtoVoices_Model.Stop.value) ]))) ]);
                return svg;
            };
        };
    };
};
var renderSlice = function (sett) {
    return function (selection) {
        return function (v) {
            var svgx = scalex(sett)(v.slice.x) - noteSize / 2.0;
            var selIsRoot = (function () {
                if (selection instanceof Data_Maybe.Just) {
                    return eq1(selection.value0.expl)(ProtoVoices_Model.RootExpl.value);
                };
                if (selection instanceof Data_Maybe.Nothing) {
                    return false;
                };
                throw new Error("Failed pattern match at Render (line 147, column 15 - line 149, column 21): " + [ selection.constructor.name ]);
            })();
            var mknode = function (text) {
                return function (title) {
                    return function (xcoord) {
                        return function (ycoord) {
                            return function (selStatus) {
                                return function (attr) {
                                    var label = Halogen_Svg_Elements.element("text")([ Halogen_Svg_Attributes.x(xcoord), Halogen_Svg_Attributes.y(ycoord), Halogen_Svg_Attributes.textAnchor(Halogen_Svg_Attributes_TextAnchor.AnchorMiddle.value), Halogen_Svg_Attributes.dominantBaseline(Halogen_Svg_Attributes_Baseline.BaselineMiddle.value), Halogen_HTML_Properties.style("pointer-events: none;"), Halogen_Svg_Attributes.fill((function () {
                                        var $218 = eq4(selStatus)(NotSelected.value);
                                        if ($218) {
                                            return black;
                                        };
                                        return white;
                                    })()) ])([ Halogen_HTML_Core.text(text) ]);
                                    var bg = Halogen_Svg_Elements.rect([ Halogen_Svg_Attributes.x(xcoord - noteSize / 2.0), Halogen_Svg_Attributes.y(ycoord - offset(1) / 2.0), Halogen_Svg_Attributes.width(noteSize), Halogen_Svg_Attributes.height(offset(1)), Halogen_Svg_Attributes.fill((function () {
                                        if (selStatus instanceof NotSelected) {
                                            return white;
                                        };
                                        if (selStatus instanceof Selected) {
                                            return selColorInner;
                                        };
                                        if (selStatus instanceof Related) {
                                            return selColorInner$prime;
                                        };
                                        throw new Error("Failed pattern match at Render (line 162, column 15 - line 165, column 42): " + [ selStatus.constructor.name ]);
                                    })()), Halogen_Svg_Attributes.class_("node") ]);
                                    return Halogen_Svg_Elements.g(attr)([ bg, label, Halogen_Svg_Elements.title([  ])([ Halogen_HTML_Core.text(title) ]) ]);
                                };
                            };
                        };
                    };
                };
            };
            var mknote = function (i) {
                return function (v1) {
                    var nselectable = v.depth !== 0.0;
                    var nodeselected = noteSelectionStatus(selection)(v1.note);
                    var attrsSel = [ cursor("pointer"), Halogen_HTML_Events.onClick(function (_ev) {
                        if (nselectable) {
                            return new Common.Select((function () {
                                var $223 = eq4(nodeselected)(Selected.value);
                                if ($223) {
                                    return Data_Maybe.Nothing.value;
                                };
                                return new Data_Maybe.Just({
                                    note: v1.note,
                                    expl: v1.expl
                                });
                            })());
                        };
                        return Common.NoOp.value;
                    }) ];
                    return mknode(show(v1.note.pitch))(Common.showExplanation(v1.expl))(scalex(sett)(v.slice.x))(scaley(sett)(v.depth) + offset(i))(nodeselected)((function () {
                        if (nselectable) {
                            return attrsSel;
                        };
                        return [  ];
                    })());
                };
            };
            if (v.slice.notes instanceof ProtoVoices_Model.Inner) {
                return Halogen_Svg_Elements.g([  ])([ Halogen_Svg_Elements.g([  ])(append([ Halogen_Svg_Elements.rect([ Halogen_Svg_Attributes.x(svgx), Halogen_Svg_Attributes.y(scaley(sett)(v.depth) - noteSize / 2.0), Halogen_Svg_Attributes.width(noteSize), Halogen_Svg_Attributes.height(offset(Data_Array.length(v.slice.notes.value0) - 1 | 0) + noteSize), Halogen_Svg_Attributes.fill(white), Halogen_Svg_Attributes.class_("slice") ]) ])(Data_Array.mapWithIndex(mknote)(v.slice.notes.value0))) ]);
            };
            return mknode(show2(v.slice.notes))(show2(v.slice.notes))(scalex(sett)(v.slice.x))(scaley(sett)(v.depth))((function () {
                if (selIsRoot) {
                    return Related.value;
                };
                return NotSelected.value;
            })())([  ]);
        };
    };
};
var renderTrans = function (sett) {
    return function (selection) {
        return function (slices) {
            return function (v) {
                return Data_Maybe.fromMaybe(Halogen_HTML_Core.text(""))(bind(lookup(v.left)(slices))(function (v1) {
                    return bind(lookup(v.right)(slices))(function (v2) {
                        var selectable = v1.depth === 0.0 && v2.depth === 0.0;
                        var mkedge = function (isPassing) {
                            return function (v3) {
                                var offr = findPitchIndex(v3.right)(v2.slice.notes);
                                var offl = findPitchIndex(v3.left)(v1.slice.notes);
                                var edgeSelected = Common.noteIsSelected(selection)(v3.left) || Common.noteIsSelected(selection)(v3.right);
                                return Halogen_Svg_Elements.line([ Halogen_Svg_Attributes.x1(scalex(sett)(v1.slice.x)), Halogen_Svg_Attributes.y1(scaley(sett)(v1.depth) + offset(offl)), Halogen_Svg_Attributes.x2(scalex(sett)(v2.slice.x)), Halogen_Svg_Attributes.y2(scaley(sett)(v2.depth) + offset(offr)), Halogen_Svg_Attributes.stroke((function () {
                                    if (edgeSelected) {
                                        return selColorInner;
                                    };
                                    return black;
                                })()), Halogen_Svg_Attributes.strokeWidth(1.0), Halogen_HTML_Properties.attr("stroke-dasharray")((function () {
                                    if (isPassing) {
                                        return "6,3";
                                    };
                                    return "";
                                })()) ]);
                            };
                        };
                        var edgeLines = append(map(mkedge(false))(fromFoldable1(v.edges.regular)))(map(mkedge(true))(fromFoldable4(v.edges.passing)));
                        var bar = [ Halogen_Svg_Elements.line([ Halogen_Svg_Attributes.x1(scalex(sett)(v1.slice.x)), Halogen_Svg_Attributes.y1(scaley(sett)(v1.depth)), Halogen_Svg_Attributes.x2(scalex(sett)(v2.slice.x)), Halogen_Svg_Attributes.y2(scaley(sett)(v2.depth)), Halogen_Svg_Attributes.stroke(lightgray), Halogen_Svg_Attributes.strokeWidth((function () {
                            if (selectable) {
                                return noteSize / 2.0;
                            };
                            return 5.0;
                        })()) ]) ];
                        return pure(Halogen_Svg_Elements.g([  ])(append(bar)(edgeLines)));
                    });
                }));
            };
        };
    };
};
var renderReduction = function (sett) {
    return function (graph) {
        return function (selection) {
            var width = scalex(sett)(graph.maxx + 2.0);
            var svgTranss = map(renderTrans(sett)(selection)(graph.slices))(fromFoldable3(Data_Map_Internal.values(graph.transitions)));
            var svgSlices = map(renderSlice(sett)(selection))(fromFoldable3(Data_Map_Internal.values(graph.slices)));
            var svgHoris = map(renderHori(sett)(selection)(graph.slices))(fromFoldable3(graph.horis));
            var deepestSize = Data_Maybe.fromMaybe(1)(maximum(map1(function ($269) {
                return (function (ns) {
                    return max(Data_Array.length(ns))(1);
                })(ProtoVoices_Model.getInnerNotes((function (v) {
                    return v.slice;
                })($269)));
            })(Data_List.filter(function (s) {
                return s.depth === graph.maxd;
            })(Data_Map_Internal.values(graph.slices)))));
            var height = scaley(sett)(graph.maxd) + offset(deepestSize + 1 | 0);
            var css = Halogen_Svg_Elements.defs([  ])([ Halogen_HTML_Elements.style_([ Halogen_HTML_Core.text(".node, .slice { stroke: none; }") ]) ]);
            return Halogen_HTML_Elements.div_([ Halogen_Svg_Elements.svg([ Halogen_Svg_Attributes.width(width), Halogen_Svg_Attributes.height(height), Halogen_Svg_Attributes.viewBox(-scalex(sett)(1.0))(-offset(1))(width)(height) ])(append([ css ])(append(svgTranss)(append(svgHoris)(svgSlices)))) ]);
        };
    };
};
var axisHeight = /* #__PURE__ */ offset(2);
var renderScoreSVG = function (sett) {
    return function (graph) {
        return function (isComplete) {
            return function (staffType) {
                var width = scalex(sett)(graph.maxx + 1.0) + sliceWidth / 2.0;
                var systemHeight = (function () {
                    var $264 = eq3(staffType)(ProtoVoices_Model.GrandStaff.value);
                    if ($264) {
                        return scoreHeightGrand;
                    };
                    return scoreHeightSingle;
                })();
                var surfaceRows = (function () {
                    if (sett.showSurface) {
                        return 1.0;
                    };
                    return 0.0;
                })();
                var extraRows = (function () {
                    if (isComplete) {
                        return 0.0;
                    };
                    return 1.0;
                })();
                var height = systemHeight * (graph.maxd + surfaceRows + extraRows) + axisHeight;
                return Halogen_HTML_Elements.div_([ Halogen_Svg_Elements.svg([ Halogen_Svg_Attributes.width(width), Halogen_Svg_Attributes.height(height), Halogen_Svg_Attributes.viewBox(-scalex(sett)(1.0))(0.0)(width)(height), Halogen_HTML_Core.ref(map2(function ($270) {
                    return Halogen_Query_Input.Action.create(Common.RegisterScoreElt.create($270));
                })), Halogen_HTML_Properties.style("overflow: visible;") ])([ Halogen_Svg_Elements.element("svg")([ Halogen_HTML_Properties.style("overflow: visible;"), Halogen_HTML_Properties.ref("scoreStaff") ])([  ]) ]) ]);
            };
        };
    };
};
export {
    sliceWidth,
    scalex,
    scaley,
    offset,
    noteSize,
    innerFactor,
    scoreHeightGrand,
    scoreHeightSingle,
    scoreScale,
    axisHeight,
    findPitchIndex,
    cursor,
    tspan,
    dy,
    svgFilter,
    selColorOuter,
    selColorOuter$prime,
    selColorInner,
    selColorInner$prime,
    parentColor,
    warnColor,
    errColor,
    white,
    black,
    lightgray,
    NotSelected,
    Selected,
    Related,
    noteSelectionStatus,
    renderSlice,
    renderTrans,
    renderHori,
    renderInner,
    renderScoreSVG,
    renderReduction,
    eqSelectionStatus
};
